"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('clothes-skates', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M4 8C4 6.11438 4 5.17157 4.58579 4.58579C5.17157 4 6.11438 4 8 4H18C19.8856 4 20.8284 4 21.4142 4.58579C22 5.17157 22 6.11438 22 8V11.5C22 13.6335 22 14.7003 22.2861 15.5932C22.7905 17.1677 23.9223 18.4643 25.4142 19.1769C26.2603 19.5809 27.3173 19.7251 29.4312 20.0133L33.6214 20.5847C38.5674 21.2592 41.0404 21.5964 42.5202 23.2917C44 24.987 44 27.4829 44 32.4747V34V40C44 41.8856 44 42.8284 43.4142 43.4142C42.8284 44 41.8856 44 40 44H20L16 40L12 44H8C6.11438 44 5.17157 44 4.58579 43.4142C4 42.8284 4 41.8856 4 40V34V11.5V8Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M44 34V32.4747C44 27.4829 44 24.987 42.5202 23.2917C41.0404 21.5964 38.5674 21.2592 33.6214 20.5847L29.4312 20.0133C27.3173 19.7251 26.2603 19.5809 25.4142 19.1769C23.9223 18.4643 22.7905 17.1677 22.2861 15.5932C22 14.7003 22 13.6335 22 11.5V11.5M44 34V40C44 41.8856 44 42.8284 43.4142 43.4142C42.8284 44 41.8856 44 40 44H20L16 40L12 44H8C6.11438 44 5.17157 44 4.58579 43.4142C4 42.8284 4 41.8856 4 40V34M44 34H4M4 34V11.5M4 11.5V8C4 6.11438 4 5.17157 4.58579 4.58579C5.17157 4 6.11438 4 8 4H18C19.8856 4 20.8284 4 21.4142 4.58579C22 5.17157 22 6.11438 22 8V11.5M4 11.5H22",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    cx: "15",
    cy: "23",
    r: "3",
    fill: props.innerFillColor,
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;